"use client";

import React from "react";
import StatsBand from "@/components/StatsBand";
export default function TrustedByResearchers() {
  return <StatsBand />;
}